// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m5-c";
export var backButton = "_m5-4";
export var backIcon = "_m5-5";
export var chevronShortcut = "_m5-6";
export var container = "_m5-1";
export var editor = "_m5-8";
export var editorWrapper = "_m5-7";
export var prefix = "_m5-2";
export var searchIcon = "_m5-3";
export var suffix = "_m5-9";
export var suffixContent = "_m5-a";
export var suffixText = "_m5-b";
export var wrapper = "_m5-0";